class customRangeSlider {
    constructor(fromSliderId, toSliderId, fromInputId, toInputId, fromInputValueId, toInputValueId, multiRange, rangeStopCallback, sliderColor = "#f0f0f0", rangeColor = "#71A891") {
       console.log('Slider Init');
        if(sliderColor == ''){
            sliderColor = '#f0f0f0';
        }
        if(rangeColor == ''){
            rangeColor = '#71A891';
        }
        this.fromSlider = document.getElementById(fromSliderId);
        this.toSlider = document.getElementById(toSliderId);
        this.fromInput = document.getElementById(fromInputId);
        this.toInput = document.getElementById(toInputId);
        this.controlSlider = this.toSlider;
        this.rangeStopCallback = rangeStopCallback;
        this.fromInputValueId = document.getElementById(fromInputValueId) || null;
        this.toInputValueId = document.getElementById(toInputValueId) || null;
        this.multiRange = multiRange;
        this.sliderColor = sliderColor;
        this.rangeColor = rangeColor;
        // Check if any of the elements are null
        const elements = [this.fromSlider, this.toSlider, this.fromInput, this.toInput];

        if (elements.some(el => el === null || el === undefined)) {
            console.log(`Element with ID '${fromSliderId}' not found`);
            return null;
        }

        if (this.multiRange) {
            this.availableValues = (this.fromSlider.dataset.available_values || "").split(",");
            this.pollElems = [];
            this.labelElems = [];
        }

        this.init();
    }
    init() {
        if (this.multiRange == true) {
            var totalVals = this.availableValues.length;

            this.fromSlider.setAttribute("min", 0);
            this.toSlider.setAttribute("min", 0);
            this.fromSlider.setAttribute("max", totalVals - 1);
            this.toSlider.setAttribute("max", totalVals - 1);
            // Setting default values
            this.fromSlider.setAttribute("value", 0);
            this.toSlider.setAttribute("value", totalVals - 1);
            this.fromInput.setAttribute("value", 0);
            this.toInput.setAttribute("value", totalVals - 1);
            // Initializing the Lables

            var labelContainer = document.createElement("div");
            labelContainer.classList.add("from-slider-label");
            this.toSlider.insertAdjacentElement("afterend", labelContainer);
            for (var i = 0; i < this.availableValues.length; i++) {
                var pollDiv = document.createElement("div");
                pollDiv.classList.add("vdb-grid-pol");
                pollDiv.textContent = "";
                pollDiv.style.left = (i / (totalVals-1)) * 100 + "%";
                labelContainer.appendChild(pollDiv);
                this.pollElems.push(pollDiv);

                const whiteColorValues = ["D", "E", "F", "G", "H", "I", "J"];

                 var label = document.createElement("label");
                 label.classList.add("vdb-grid-slider-label");
                 label.setAttribute("data-value", whiteColorValues[i]);  

                label.textContent = this.availableValues[i];
                label.style.left = (i / (totalVals-1)) * 100 + "%";
                labelContainer.appendChild(label);

                label.style.marginLeft = '-'+parseFloat(label.offsetWidth / 2)+'px';
                this.labelElems.push(label);
            }
            /*this.pollElems[0].classList.add("vdb-active-poll");
            this.pollElems[totalVals-1].classList.add("vdb-active-poll");

            this.labelElems[0].classList.add("vdb-slider-label-active");
            this.labelElems[totalVals-1].classList.add("vdb-slider-label-active");*/
        }
        this.fillSlider(this.fromSlider, this.toSlider, this.sliderColor, this.rangeColor);
        this.fromSlider.addEventListener("input", () => this.controlFromSlider());
        this.toSlider.addEventListener("input", () => this.controlToSlider());
        this.fromInput.addEventListener("blur", () => this.controlFromInput());
        this.toInput.addEventListener("blur", () => this.controlToInput());
        this.fromInput.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                this.blur(); // Trigger the blur event
            }
        });
        this.toInput.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                this.blur(); // Trigger the blur event
            }
        });
        // Add event listeners for the 'mouseup' event to trigger the callback when the user stops dragging the sliders
        this.fromSlider.addEventListener("mouseup", () => this.handleRangeStop());
        this.toSlider.addEventListener("mouseup", () => this.handleRangeStop());
        this.fromSlider.addEventListener("touchend", () => this.handleRangeStop());
        this.toSlider.addEventListener("touchend", () => this.handleRangeStop());
    }
    getParsed(currentFrom, currentTo) {
        let from = parseFloat(currentFrom.value);
        let to = parseFloat(currentTo.value);
        return [from, to];
    }
    fillSlider(from, to, sliderColor, rangeColor) {
        let rangeDistance = to.max - to.min;
        let fromPosition = from.value - to.min;
        let toPosition = to.value - to.min;
        if (fromPosition > toPosition) {
            let spare = fromPosition;
            fromPosition = toPosition;
            toPosition = spare;
        }

        this.controlSlider.style.background = `linear-gradient(
            to right,
        ${sliderColor} 0%,
    ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
    ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
    ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
    ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
    ${sliderColor} 100%)`;

        if (this.multiRange == true) {
            this.pollElems.forEach(sliderPol => { sliderPol.classList.remove("vdb-active-poll"); });
            this.pollElems[from.value].classList.add("vdb-active-poll");
            this.pollElems[to.value].classList.add("vdb-active-poll");

            this.labelElems.forEach(sliderlbl => { sliderlbl.classList.remove("vdb-slider-label-active"); });
            this.labelElems[from.value].classList.add("vdb-slider-label-active");
            this.labelElems[to.value].classList.add("vdb-slider-label-active");
        }
    }
    controlFromInput(){
        let [from, to] = this.getParsed(this.fromInput, this.toInput);
        this.fromSlider.value = from;
        if (from > to) {
            this.fromSlider.value = to;
            this.fromInput.value = to;
        }
        else {
            this.fromSlider.value = from;
            this.toSlider.value = to;
        }
        this.fillSlider(this.fromInput, this.toInput, this.sliderColor, this.rangeColor);
    }
    controlToInput(){
        let [from, to] = this.getParsed(this.fromInput, this.toInput);
        to = to.toFixed(2);

        this.fromSlider.value = from;
        this.toSlider.value = to;
        this.toInput.value = to;
        if (from <= to) {
            this.toSlider.value = to;
            this.toInput.value = to;
        }
        else {
            this.toInput.value = from;
            this.fromInput.value = to;
        }
        this.fillSlider(this.fromInput, this.toInput, this.sliderColor, this.rangeColor);
    }
    controlFromSlider() {
        if(document.activeElement == this.fromInput){
            this.fromInput.blur();
        }
        if(document.activeElement == this.toInput){
            this.toInput.blur();
        }

        let [from, to] = this.getParsed(this.fromSlider, this.toSlider);
        this.fillSlider(this.fromSlider, this.toSlider, this.sliderColor, this.rangeColor);

        this.fromInput.value = from;
        this.toInput.value = to;
        if (from >= to) {
            this.fromInput.value = to;
            this.toInput.value = from;
        }
    }
    controlToSlider() {
        if(document.activeElement == this.fromInput){
            this.fromInput.blur();
        }
        if(document.activeElement == this.toInput){
            this.toInput.blur();
        }

        let [from, to] = this.getParsed(this.fromSlider, this.toSlider);
        this.fillSlider(this.fromSlider, this.toSlider, this.sliderColor, this.rangeColor);

        this.fromInput.value = from;
        this.toSlider.value = to;
        this.toInput.value = to;
        if (from >= to) {
            this.fromInput.value = to;
            this.toInput.value = from;
        }
    }
    handleRangeStop() {
        // Trigger the callback function when the user stops dragging the sliders
        if (typeof this.rangeStopCallback === 'function') {
            const [from, to] = this.getParsed(this.fromInput,this.toInput);
            this.rangeStopCallback(from, to);
        }
    }
    resetSlider(){
        this.fromSlider.value = this.fromSlider.dataset.value;
        this.toSlider.value = this.toSlider.dataset.value;
        this.fromInput.value = this.fromInput.dataset.value;
        this.toInput.value = this.toInput.dataset.value;
        this.fillSlider(this.fromSlider, this.toSlider, this.sliderColor, this.rangeColor);
    }
}